var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-desktop-header"},[_c('div',{staticClass:"account-desktop-header__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.isExportAvailable)?_c('button',{staticClass:"account-desktop-header__button account-desktop-header__button--export",on:{"click":_vm.onExport}},[_vm._v("Export")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-403fe3ec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/account-desktop-header/account-desktop-header.vue
// module id = nPGV
// module chunks = 65